import { render, staticRenderFns } from "./Kontrollgang.vue?vue&type=template&id=6010a054&"
import script from "./Kontrollgang.vue?vue&type=script&lang=js&"
export * from "./Kontrollgang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports